import { gql } from 'graphql-tag'
import { fragmentModuleMedia } from '../../../core/data-layer/modules/fragments'

export default (pageContentType: string) => gql`
  ${fragmentModuleMedia}
  fragment ${pageContentType}Fragment on ${pageContentType} {
    sys {
      id
    }
    title
    slug
    hero {
      image {
        ...ModuleMediaFragment
      }
    }
  }
`
